import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";

// Placeholder rows shown while the feature menu is still fetching (the store's
// `loaded` is false). Geometry mirrors a depth-0 SideNavItem leaf — icon 20px +
// mr:2, pl/pr 16px, py 6px — so the bars sit exactly where the real items land
// and the swap-in is jump-free.
//
// The nav bar is always dark (secondary.main), regardless of the app theme, so
// the default MUI skeleton tint (which follows the app mode) can be invisible
// here — force a translucent-white fill like the nav's own hover/active states.
const SKELETON_BG = "rgba(255, 255, 255, 0.08)";

// Varied widths so the rows read like feature labels of different lengths
// rather than an obvious repeat.
const ROW_WIDTHS = ["60%", "45%", "72%", "50%", "66%", "40%", "58%"];

export const NavSkeleton = ({ count = 7 }) => (
  <Stack
    component="ul"
    aria-hidden
    spacing={0.5}
    sx={{ listStyle: "none", m: 0, p: 0 }}
  >
    {Array.from({ length: count }, (_, index) => (
      <Box
        key={index}
        component="li"
        sx={{
          alignItems: "center",
          display: "flex",
          pl: "16px",
          pr: "16px",
          py: "6px",
        }}
      >
        <Skeleton
          variant="circular"
          width={20}
          height={20}
          sx={{ bgcolor: SKELETON_BG, flexShrink: 0, mr: 2 }}
        />
        <Skeleton
          variant="text"
          width={ROW_WIDTHS[index % ROW_WIDTHS.length]}
          height={20}
          sx={{ bgcolor: SKELETON_BG }}
        />
      </Box>
    ))}
  </Stack>
);

NavSkeleton.propTypes = {
  count: PropTypes.number,
};
